module.exports = __webpack_public_path__ + "static/media/tournesol.5375b8f5.jpg";